/* eslint-disable */
import React from "react";
import { Tooltip } from "antd";

const TooltipBox = (props) => {
  return <Tooltip title={props.title}>{props.children}</Tooltip>;
};
export default TooltipBox;
